import { render, staticRenderFns } from "./SigisLicenseAgreement.vue?vue&type=template&id=611da2b7"
import script from "./SigisLicenseAgreement.vue?vue&type=script&lang=ts"
export * from "./SigisLicenseAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports